import styles from './style/Switch.module.scss';

const Switch = ({
  isChecked,
  onChange,
  isTransparent = false,
  color = { on: '#5856d6', off: '#dddddd' },
  width = 45,
  height = 25,
  className = '',
  disabled = false,
}) => {
  const safeWidth = Math.max(Number(width) || 45, 28);
  const safeHeight = Math.max(Number(height) || 25, 18);
  const trackRadius = safeHeight;
  const padding = 2;
  const knobSize = Math.max(safeHeight - padding * 2, 12);
  const translateX = Math.max(safeWidth - knobSize - padding * 2, 0);

  const cssVars = {
    '--switch-width': `${safeWidth}px`,
    '--switch-height': `${safeHeight}px`,
    '--switch-radius': `${trackRadius}px`,
    '--switch-knob-size': `${knobSize}px`,
    '--switch-knob-offset': `${padding}px`,
    '--switch-knob-translate': `${translateX}px`,
    '--switch-track-color': isChecked ? color.on : color.off,
  };

  return (
    <label className={`${styles.switch} ${disabled ? styles.disabled : ''} ${className}`} style={cssVars}>
      <input
        type='checkbox'
        checked={isChecked}
        onChange={!disabled ? onChange : () => {}}
        disabled={disabled}
      />
      <span className={isTransparent ? styles.sliderTransparent : styles.slider} />
    </label>
  );
};

export default Switch;
